/**
 * Shared person-name rule for Enrollio Forms (ENR-1474).
 * Letters including accented letters, spaces, hyphen, apostrophe and period,
 * max 50 characters. Mirrors enrollio-be src/forms/form-validation.ts;
 * keep both copies in sync.
 */
export const FORM_PERSON_NAME_MAX_LENGTH = 50;

/** Owner-editable copy limits — keep in sync with enrollio-be forms/constants.ts */
export const FORM_NAME_MAX_LENGTH = 80;
export const FORM_TITLE_MAX_LENGTH = 80;
export const FORM_SUBMIT_LABEL_MAX_LENGTH = 40;
export const FORM_INTRO_TEXT_MAX_LENGTH = 280;
export const FORM_CONSENT_TEXT_MAX_LENGTH = 500;
export const FORM_INTEREST_OPTION_MAX_LENGTH = 80;
export const FORM_INTEREST_OPTIONS_MAX_COUNT = 12;

// Lookahead requires at least one letter so all-punctuation input fails.
export const FORM_PERSON_NAME_PATTERN = new RegExp(
  `^(?=.*\\p{L})[\\p{L}\\p{M} .'\\u2019-]{1,${FORM_PERSON_NAME_MAX_LENGTH}}$`,
  'u',
);

export function isValidFormPersonName(
  value: string | null | undefined,
): boolean {
  return typeof value === 'string' && FORM_PERSON_NAME_PATTERN.test(value);
}

export function isOverFormFieldLimit(value: string, max: number): boolean {
  return value.length > max;
}

export function parseInterestOptions(text: string): string[] {
  return text
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean);
}

export function getInterestOptionsLimitError(
  text: string,
): string | null {
  const options = parseInterestOptions(text);
  if (options.length > FORM_INTEREST_OPTIONS_MAX_COUNT) {
    return `At most ${FORM_INTEREST_OPTIONS_MAX_COUNT} interest options.`;
  }
  const tooLong = options.find(
    (option) => option.length > FORM_INTEREST_OPTION_MAX_LENGTH,
  );
  if (tooLong) {
    return `Each interest option must be ${FORM_INTEREST_OPTION_MAX_LENGTH} characters or fewer.`;
  }
  return null;
}
